module.exports = __webpack_public_path__ + "static/img/设计师1.f03816c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/设计师1.jpg
// module id = Gv0f
// module chunks = 1